import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { createProject } from '../../actions/projectAction';
import { connect } from 'react-redux';

class ProjectCreateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createFrom: 'empty', // empty, commit, package, project
      title: '',
      description: '',
      assigned_to: '',
      start_branch_id: '',
      parent_checkpoint_id: '',
      source_id: '' // ID of commit/package/project to create from
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { createFrom, title, description, assigned_to, start_branch_id, parent_checkpoint_id, source_id } = this.state;
    
    const projectData = {
      title,
      description,
      assigned_to,
      start_branch_id,
      parent_checkpoint_id,
      metadata: {
        created_from: createFrom,
        source_id: createFrom !== 'empty' ? source_id : undefined
      }
    };

    this.props.createProject(projectData);
    this.props.toggle();
  }

  render() {
    const { isOpen, toggle } = this.props;
    const { createFrom, title, description, assigned_to, start_branch_id, parent_checkpoint_id, source_id } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Create New Project</ModalHeader>
        <Form onSubmit={this.handleSubmit}>
          <ModalBody>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Create From</Label>
                  <Input
                    type="select"
                    value={createFrom}
                    onChange={(e) => this.setState({ createFrom: e.target.value })}
                  >
                    <option value="empty">Empty Project</option>
                    <option value="checkpoint">From Checkpoint</option>
                    <option value="package">From Package</option>
                    <option value="project">From Project</option>
                  </Input>
                </FormGroup>
              </Col>
              {createFrom !== 'empty' && (
                <Col md="6">
                  <FormGroup>
                    <Label>Source ID</Label>
                    <Input
                      type="text"
                      value={source_id}
                      onChange={(e) => this.setState({ source_id: e.target.value })}
                      placeholder={`Enter ${createFrom} ID`}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Title</Label>
                  <Input
                    type="text"
                    value={title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Assigned To</Label>
                  <Input
                    type="text"
                    value={assigned_to}
                    onChange={(e) => this.setState({ assigned_to: e.target.value })}
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label>Description</Label>
              <Input
                type="textarea"
                value={description}
                onChange={(e) => this.setState({ description: e.target.value })}
              />
            </FormGroup>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Start Branch ID</Label>
                  <Input
                    type="text"
                    value={start_branch_id}
                    onChange={(e) => this.setState({ start_branch_id: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Parent Checkpoint ID</Label>
                  <Input
                    type="text"
                    value={parent_checkpoint_id}
                    onChange={(e) => this.setState({ parent_checkpoint_id: e.target.value })}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>Cancel</Button>
            <Button color="primary" type="submit">Create</Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default connect(null, { createProject })(ProjectCreateModal); 